import { Component, OnInit } from '@angular/core';
import { UtilitaService } from '../../services/utilita.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';



@Component({
  selector: 'app-messaggio-ok',
  templateUrl: './messaggio-ok.component.html',
  styleUrls: ['./messaggio-ok.component.css']
})
export class MessaggioOkComponent implements OnInit {
  lstPercorsoImmagine: any;
  id: string = '500';



  constructor(private srvUtilita: UtilitaService, private dialog: MatDialog,
    public dialogRef: MatDialogRef<MessaggioOkComponent>,
    private router: Router) { }

  ngOnInit(): void {
    this.srvUtilita.getLista('Utenti/getPercorso?id=' + this.id).subscribe((res: any) => {
      this.lstPercorsoImmagine = res
    })
  }

  btnEsci() {
    window.open('https://www.gii-idraulica.it/')
    this.dialogRef.close();
  }

}
